<template>
  <div class="form-field form-toggle" :rel="name" v-bind:class="{'form-required': requiredForm, 'form-disabled':isDisabled}">
    <div class="form-label" v-if="label">
      {{ label }}
      <div class="form-hint" v-show="hint">{{ hint }}</div>
    </div>
    <div class="form-input">
      <div class="form-input-wrapper">
        <label>
          <input type="checkbox" v-model="internalValue" :disabled="disabled == 1"/>
          <span class="on">{{ labelTrue ? labelTrue : "oui" }}</span>
          <span class="off">{{ labelFalse ? labelFalse : "non" }}</span>
          <span class="switch"></span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Toggle',
  props: ['value', 'hint', 'label', 'name', 'placeholder', 'index', 'labelTrue', 'labelFalse', 'callback', 'required', 'disabled'],
  data: function () {
    return {
      internalValue: '',
      width: 40
    }
  },
  created: function () {
    this.internalValue = this.property ? this.value[this.property] : this.value;
    let widthTrue = (this.labelTrue ? this.labelTrue.length * 10 : 70);
    let widthFalse = (this.labelFalse ? this.labelFalse.length * 10 : 70);
    this.width = widthTrue > widthFalse ? widthTrue : widthFalse;
    this.onChange = this.callback ? true : false;
    this.requiredForm = this.required && (this.required == 'true' || this.required == true) ? true : false
    this.setDisabled(this.disabled)
  },
  methods: {
    setDisabled: function (value) {
      this.isDisabled = value && (value == 'true' || value == true) ? true : false
      this.$forceUpdate();
    }
  },
  watch: {
    'disabled'(newVal, oldVal) {
      this.setDisabled(newVal)
    },
    'value'(newVal, oldVal) {
      if (typeof newVal !== "undefined") {
        newVal = (newVal == "1" || newVal == 1) ? 1 : 0;
      }
      this.internalValue = newVal;
    },
    'internalValue'(newVal, oldVal) {
      var val = this.internalValue
      if (typeof val !== "undefined") {
        val = (val == "1" || val == 1) ? 1 : 0;
      }
      this.$emit('input', val);
      this.$emit('event', {index: this.index, value: val});
      if (this.onChange) {
        this.callback(val)
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/form/Toggle.vue